
export const myAppNamespace = 'my-app';
export interface ControllerInterface {}

export const myAppPromiseFunctions = [];